<template>
    <div v-if="hasQuotaLimit" class="cb-history-footer">
        <div class="cb-sub-limit">
            <div class="cb-sub-limit-header">
                <div class="cb-sub-limit-title">{{ $t('frm_total_sub_queries') }}</div>
                <div class="cb-sub-limit-sub-title">{{  getItem('quotaUsed') }} of {{  getItem('quotaAvailable') }}</div>
            </div>
            <div class="cb-sub-limit-quota-bar">
                <div :class="quotaClass" :style="quotaStyle">&nbsp;</div>
            </div>
            <div class="cb-sub-limit-footer">{{ getItem('quotaAvailable')}}({{(100-quotaUsedPercentage)}}%) {{ $t('frm_remaining') }}</div>
        </div>    
    </div>
</template>
<script>
    import { createNamespacedHelpers } from 'vuex';
    const { mapGetters: aiChatMapGetters } = createNamespacedHelpers('aichat')
    export default {
        name: "ChatQuotaUsed",
        computed: {
            ...aiChatMapGetters([
                'getItem'
            ]),
            hasQuotaLimit() {
                return this.getItem('quotaAvailable') >= 0;
            },
            quotaUsedPercentage() {
                const quotaAvailable = this.getItem('quotaAvailable');
                const quotaUsed = this.getItem('quotaUsed');
                const percentage = quotaAvailable === 0 ? 100 : (quotaUsed / quotaAvailable) * 100;
                return Math.round(percentage);
            },
            quotaClass() {
                let colorClass = 'green';
                const percentage = this.quotaUsedPercentage;
                if (percentage > 80) {
                    colorClass = 'red';
                }
                else if (percentage > 50) {
                    colorClass ='yellow';
                }
                return ['cb-sub-limit-used', colorClass]
            },
            quotaStyle() {
                return {
                    width: `${this.quotaUsedPercentage}%` // Ensures width never exceeds 100%
                };
            }

        }
    }
</script>